import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Confirmation from "./component";

import {
  getInsightfulContent,
  sendToFriendReportOnEmail,
} from "../dashboard/actions";
import { getAssessmentResultByAssessmentAttemptId } from "../plan/actions";
import BigFiveFacetsReport from "./component";
import { GetUserById } from "../settings/actions";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInsightfulContentConnect: getInsightfulContent,
      getAssessmentResultByAssessmentAttemptIdConnect:
        getAssessmentResultByAssessmentAttemptId,
      sendToFriendReportOnEmailConnect: sendToFriendReportOnEmail,
      getUserByIdConnect: GetUserById,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BigFiveFacetsReport);
